<template>
    <div class="my-toolbar">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "MyToolbar"
    }
</script>

<style scoped>
    .my-toolbar {
        margin: 0 -20px 20px -20px;
        width: 100% !important;
    }
    .my-toolbar:before, .my-toolbar:after {
        content: "";
        display: block;
    }
    .my-toolbar:after {
        clear: both;
    }
</style>